import { render, staticRenderFns } from "./Receipt-report.vue?vue&type=template&id=147e3121&scoped=true"
import script from "./Receipt-report.vue?vue&type=script&lang=js"
export * from "./Receipt-report.vue?vue&type=script&lang=js"
import style0 from "./Receipt-report.vue?vue&type=style&index=0&id=147e3121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e3121",
  null
  
)

export default component.exports